"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateInputDate = exports.returnDateAsString = exports.returnDateAsArray = exports.prepareDateForDisplay = exports.initialValues = exports.formatToIso = exports.calculateReadingPeriod = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _moment = _interopRequireDefault(require("moment"));
var _GermanDateHelpers = _interopRequireDefault(require("../../../../../utils/GermanDateHelpers"));
var _GlobalErrorHandler = _interopRequireDefault(require("../../../../../utils/GlobalErrorHandler"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var formatToIso = exports.formatToIso = function formatToIso(gDate) {
  return (gDate === null || gDate === void 0 ? void 0 : gDate.split('.').reverse().join('-')) || '';
};
var validateInputDate = exports.validateInputDate = function validateInputDate(value, readingPeriod, dateValidationErrors) {
  if (!value) {
    return _GlobalErrorHandler.default.getErrorMessage('required').toString();
  }
  if (!_GermanDateHelpers.default.isValidGermanDateFormat(value)) {
    return dateValidationErrors.dateValidationError;
  }
  if ((0, _moment.default)(readingPeriod.startDate).unix() > (0, _moment.default)(formatToIso(value)).unix()) {
    return dateValidationErrors.dateRangeErrorMsg;
  }
  if ((0, _moment.default)(readingPeriod.endDate).unix() < (0, _moment.default)(formatToIso(value)).unix()) {
    return dateValidationErrors.futureDateErrorMessage;
  }
  return '';
};
var calculateReadingPeriod = exports.calculateReadingPeriod = function calculateReadingPeriod(readingPeriod) {
  var startDate = readingPeriod.from;
  var endDate = readingPeriod.to;
  return {
    startDate: new Date(startDate[0], startDate[1] - 1, startDate[2]),
    endDate: new Date(endDate[0], endDate[1] - 1, endDate[2])
  };
};
var prepareDateForDisplay = exports.prepareDateForDisplay = function prepareDateForDisplay(registers) {
  var dates = registers.map(function (register) {
    var year = register.lastReadingDate[0];
    var month = register.lastReadingDate[1];
    if (month.toString().length === 1) {
      month = "0".concat(month);
    }
    var day = register.lastReadingDate[2];
    if (day.toString().length === 1) {
      day = "0".concat(day);
    }
    var newDate = "".concat(month, "/").concat(day, "/").concat(year);
    return new Date(newDate);
  });

  // sort dates to most actual
  dates.sort(function (x, y) {
    return x.getDate() - y.getDate();
  });
  return _GermanDateHelpers.default.dateToGermanString(dates[0]);
};
var returnDateAsString = exports.returnDateAsString = function returnDateAsString(dateAsArray) {
  var year = dateAsArray[0];
  var month = dateAsArray[1];
  if (month.toString().length === 1) {
    month = "0".concat(month);
  }
  var day = dateAsArray[2];
  if (day.toString().length === 1) {
    day = "0".concat(day);
  }
  var dateAsString = "".concat(day, ".").concat(month, ".").concat(year);
  return dateAsString;
};
var returnDateAsArray = exports.returnDateAsArray = function returnDateAsArray(dateAsString) {
  var str = dateAsString.split('.');
  var year = parseInt(str[2], 10);
  var month = parseInt(str[1], 10);
  var day = parseInt(str[0], 10);
  var dateAsArray = [year, month, day];
  return dateAsArray;
};
var initialValues = exports.initialValues = function initialValues(deviceData) {
  var _deviceData$readingPe;
  var readingDate = returnDateAsString(deviceData === null || deviceData === void 0 ? void 0 : (_deviceData$readingPe = deviceData.readingPeriod) === null || _deviceData$readingPe === void 0 ? void 0 : _deviceData$readingPe.to);
  var readingDateValue = {
    start: (0, _moment.default)(readingDate, 'DD/MM/YYYY').toDate(),
    text: readingDate
  };
  return _objectSpread(_objectSpread({}, deviceData), {}, {
    readingDate: readingDateValue
  });
};